import { render, staticRenderFns } from "./Transload.vue?vue&type=template&id=03485a67&scoped=true&"
import script from "./Transload.vue?vue&type=script&lang=js&"
export * from "./Transload.vue?vue&type=script&lang=js&"
import style0 from "./Transload.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Transload.vue?vue&type=style&index=1&id=03485a67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03485a67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VForm,VTextField,VToolbar,VToolbarTitle})
